/** Escapes a single CSV field, quoting when it contains commas, quotes, or newlines. */
export function csvEscape(value: string): string {
  return /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

/** Serializes headers and rows into a CRLF-joined CSV string. */
export function rowsToCsv(headers: string[], rows: string[][]): string {
  return [headers, ...rows].map((cells) => cells.map(csvEscape).join(',')).join('\r\n');
}
